import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';

export const StyledLink = styled(RouterLink)`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: var(--color-text);
  padding: 0 0 5px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: var(--color-link);
  }
`;
